//#region Old Code

// import React from "react";
// import BuyerInfo from "./BuyerInfo";
// import CRUD from "../CRUD/CRUD";
// import {browserHistory} from "react-router";
// import {formatName, formatType, capitalizeAll, addSpaceAfterComma} from "../../utils";
// import {dateISOtoUS, dateUStoISO} from "../../date-converter";
// import {getData, manageData} from "../../requests/CRUD";
// import {BUYERS} from "../../consts/tables";
// import {sendBuyerEmail} from "../../requests/emailRequests";
// import BuyerCompanyInfo from "./BuyerCompanyInfo";
// import {priceToString} from "../CRUDProperty/CRUDProperty";
// import {url} from "../../consts/env";
// import request from 'arcdynamic-request';

// const limit = 1000;

// const priceProps = [
//     "PRICE_MIN",
//     "PRICE_MAX",
// ];

// const dateProps = [
//     "LAST_MODIFIED"
// ];

// function convertDataToForm(dbData) {
//     const data = {...dbData};

//     priceProps
//         .filter((key) => data[key])
//         .forEach((key) => {
//             const num = Number(data[key]);
//             if (num === num) {
//                 // !isNaN
//                 data[key] = num.toLocaleString();
//             }
//         });

//     dateProps
//         .filter(key => data[key])
//         .forEach(key => {
//             const str = dateISOtoUS(data[key]);
//             if (str !== false)
//                 data[key] = str;
//         });

//     return data;
// }

// function convertFormToData(formData) {
//     const data = {...formData};

//     priceProps.forEach((key) => {
//         const num = priceToString(data[key]);
//         if (num !== false)
//             data[key] = num;
//     });

//     dateProps
//         .filter(key => data[key])
//         .forEach(key => {
//             const str = dateUStoISO(data[key]);
//             if (str !== false)
//                 data[key] = str;
//         });

//     return data;
// }

// export default class CRUDBuyer extends React.Component {
//     constructor(props) {
//         super(props);

//         this.state = {
//             data: null,
//             original: null,
//             isBusy: null,
//             isExists: false,
//             users: [],
//             error: null,
//             success: null,
//             errorTabs: [],
//             currentTab: 0,
//             viewMode: this.props.edit || false,
//             previousStatus: null,
//         };

//         this.handleSubmit = this.handleSubmit.bind(this);
//         this.handleChangeInput = this.handleChangeInput.bind(this);
//         this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
//         this.saveData = this.saveData.bind(this);
//     }

//     componentWillReceiveProps(nextProps) {
//         if (this.props.params.id !== nextProps.params.id) {
//             this.fetch(nextProps.params.id);
//         }
//     }

//     componentDidMount() {
//         this.fetch(this.props.params.id);
//     }

//     fetch(id) {
//         this.setState({
//             data: null,
//             error: null,
//             success: null,
//         });

//         if (id === undefined) {
//             this.setState({
//                 data: {},
//                 original: {}
//             });
//             return;
//         }

//         getData({
//             tableCode: BUYERS,
//             options: {
//                 filter: [{
//                     text: id,
//                     code: "ARCIMEDES_ROW_ID",
//                     type: "exact",
//                 }],
//             },
//         }).then(res => {
//             if (res && res.success && Array.isArray(res.data) && res.data.length) {
//                 this.setState({
//                     data: convertDataToForm(res.data[0]),
//                     original: {...convertDataToForm(res.data[0])},
//                     error: null,
//                 });
//             } else {
//                 this.setState({
//                     data: false,
//                     error: res.message ? res.message : "Unidentified Error",
//                 });
//             }
//         });
//     }

//     fetchUserData(offset) {
//         const options = {
//           limit: {
//             count: limit,
//             offset: offset * limit,
//           },
//           column: [
//             'ARCIMEDES_ROW_ID',
//             'FIRST_NAME',
//             'LAST_NAME',
//             'EMAIL',
//             'PHONE',
//             'DELETED',
//           ]
//         };
//         request(arc.path.api, {
//           service: 'arcimedes',
//           action: 'open.datasource.table.Data.getData',
//           params: ['code', BUYERS, options],
//         }).then(res => {
//           this.setState(prevState => {
//             const users = prevState.users.concat(res.data);
//             return {
//               users,
//             };
//           });
//           if (res.data.length >= limit) {
//             this.fetchUserData(++offset);
//           } else {
//             const isExists = this.state.users.filter(u => (this.state.data.ARCIMEDES_ROW_ID != undefined && this.state.data.ARCIMEDES_ROW_ID != null) ? u.ARCIMEDES_ROW_ID != this.state.data.ARCIMEDES_ROW_ID: true ).find((e) => {
//               return (
//                 (e.FIRST_NAME != null && e.FIRST_NAME.toLowerCase()) == (this.state.data.FIRST_NAME != null && this.state.data.FIRST_NAME.toLowerCase()) &&
//                 (e.LAST_NAME != null && e.LAST_NAME.toLowerCase()) == (this.state.data.LAST_NAME != null && this.state.data.LAST_NAME.toLowerCase()) )
//             });
//             this.setState({
//               isExists: !!isExists,
//             })
//             if (isExists) {
//               return
//             }
//             else {
//               this.setState({ viewMode: true }, () => this.saveData());
//             }
//           }
//         });
//       }

//     handleSubmit(e) {
//         e.preventDefault();

//         if (this.state.viewMode) this.setState({viewMode: false});
//         if  (!this.state.data.FIRST_NAME ||
//             !this.state.data.LAST_NAME) {
//             this.setState({errorTabs: [0], success: null});
//             return;
//         } else {
//             if (this.state.isBusy || this.state.viewMode === true) return;
//             this.setState({errorTabs: []});
//             this.fetchUserData(0);
//         }
//     }

//     handleChangeInput(key, value) {
//         this.setState({
//             data: Object.assign(this.state.data, {[key]: value}),
//         });
//     }

//     handleChangeDropdown(query, queryType, x, key) {
//         const data = {...this.state.data};
//         if (key === 'STATUS') {
//             data.LAST_MODIFIED = new Date().toLocaleDateString("en-US");
//             if (!query[key]) {
//                 data.CATEGORY = null;
//                 data.TYPE = null;
//                 data.SINGLE_TENANT_SUBCATEGORY = null;
//                 data.MULTI_TENANT_SUBCATEGORY = null;
//                 data.MARKET = null;
//                 data.PRICE_MIN = null;
//                 data.PRICE_MAX = null;
//                 data.CAP_RATE_MIN = null;
//                 data.CAP_RATE_MAX = null;
//                 data.STRIVE_AGENT = null;
//             }
//         }
//         data[key] = query[key];
//         this.setState({data});
//     }

//     saveData() {
//         if (this.state.isBusy) return;

//         this.setState({
//             isBusy: true,
//             error: null,
//             success: null,
//         });

//         Object.keys(this.state.data).forEach((k) => {
//             if (!this.state.data[k] || k === "undefined") {
//                 const newData = {...this.state.data};
//                 delete newData[k];
//                 this.setState({data: newData});
//             }
//         });

//         Promise.all([
//             manageData({
//                 tableCode: BUYERS,
//                 data: [convertFormToData(this.state.data)],
//             }),
//             getData({
//                 tableCode: "TEAM",
//                 options: {
//                     column: ["FIRST_NAME", "LAST_NAME"],
//                     filter: [{
//                         text: this.state.data.STRIVE_AGENT ? this.state.data.STRIVE_AGENT : "",
//                         code: "ARCIMEDES_ROW_ID",
//                         type: "exact",
//                     }],
//                 },
//             }),
//         ]).then((res) => {
//             let previousStatus;
//             if (res && res[0] && res[0].success && res[1] && res[1].success) {
//                 previousStatus = this.state.original.STATUS;
//                 this.setState({
//                     isBusy: false,
//                     success: "Saved",
//                     original: res[0].data[0],
//                 }, () => {
//                     if (!this.props.edit) {
//                         browserHistory.push({
//                             pathname: `/buyer/${res[0].data[0].ARCIMEDES_ROW_ID}`,
//                         });
//                     }}
//                 );
//                 window.scrollTo(0, 0);
//             } else {
//                 this.setState({
//                     isBusy: null,
//                     data: null,
//                     original: null,
//                     error: res && res[0] && res[0].message ? res[0].message : "Unspecified error",
//                 });
//             }
//             return {
//                 success: res[0].success && res[1].success,
//                 previousStatus,
//                 STATUS: res[0].data[0].STATUS,
//                 CATEGORY: capitalizeAll(res[0].data[0].CATEGORY),
//                 TYPE: formatType(res[0].data[0].TYPE),
//                 MARKET: capitalizeAll(res[0].data[0].MARKET),
//                 TENANT_SUBCATEGORY: res[0].data[0].TYPE === "MT" ? addSpaceAfterComma(res[0].data[0].MULTI_TENANT_SUBCATEGORY) : res[0].data[0].TYPE === "STNL" ? addSpaceAfterComma(res[0].data[0].SINGLE_TENANT_SUBCATEGORY) : null,
//                 PRICE_MIN: res[0].data[0].PRICE_MIN,
//                 PRICE_MAX: res[0].data[0].PRICE_MAX,
//                 CAP_RATE_MIN: res[0].data[0].CAP_RATE_MIN,
//                 CAP_RATE_MAX: res[0].data[0].CAP_RATE_MAX,
//                 NOTES: res[0].data[0].NOTES,
//                 STRIVE_AGENT: res[1].data.length ? formatName(res[1].data[0]) : null,
//                 LINK: `${url}buyers?FIRST_NAME=${res[0].data[0].FIRST_NAME}&LAST_NAME=${res[0].data[0].LAST_NAME}`
//             };
//         }).then((res) => {
//             if (res.success && res.STATUS === '1031-Buyer')
//                 sendBuyerEmail(res);
//             if (res.success && !res.previousStatus && res.STATUS === 'Active')
//                 sendBuyerEmail(res);
//         });
//     }

//     render() {
//         const data = this.state.data;
//         const {edit, isSuper} = this.props;

//         return (
//             <CRUD
//                 tabsData={[
//                     {
//                         name: "Buyer",
//                         renderedComponent: (
//                             <BuyerInfo
//                                 isExists={this.state.isExists}
//                                 data={data}
//                                 handleChangeInput={this.handleChangeInput}
//                                 handleChangeDropdown={this.handleChangeDropdown}
//                                 viewMode={this.state.viewMode}
//                                 deleted={data && data.DELETED === "1"}
//                             />
//                         ),
//                     },
//                     {
//                         name: "Buyer Company",
//                         renderedComponent: (
//                             <BuyerCompanyInfo
//                                 data={data}
//                                 handleChangeInput={this.handleChangeInput}
//                                 handleChangeDropdown={this.handleChangeDropdown}
//                                 viewMode={this.state.viewMode}
//                                 deleted={data && data.DELETED === "1"}
//                             />
//                         ),
//                     },
//                 ]}
//                 backLink={`${arc.path.base}buyers`}
//                 edit={edit}
//                 state={this.state}
//                 setState={this.setState.bind(this)}
//                 handleSubmit={this.handleSubmit}
//                 saveData={this.saveData}
//                 type="buyer"
//                 backName="BUYERS"
//                 title={data && `${data.FIRST_NAME} ${data.LAST_NAME}`}
//                 isSuper = {isSuper}
//             />
//         );
//     }
// }
//#endregion


import React from "react";
import BuyerInfo from "./BuyerInfo";
import CRUD from "../CRUD/CRUD";
import { browserHistory } from "react-router";
import { formatName, formatType, capitalizeAll, addSpaceAfterComma, sanitizeNotesForInput } from "../../utils";
import { dateISOtoUS, dateUStoISO } from "../../date-converter";
import { getData, manageData } from "../../requests/CRUD";
import { BUYERS } from "../../consts/tables";
import { sendBuyerEmail, sendEmailNotification } from "../../requests/emailRequests";
import BuyerCompanyInfo from "./BuyerCompanyInfo";
import { priceToString } from "../CRUDProperty/CRUDProperty";
import { url } from "../../consts/env";
import request from 'arcdynamic-request';
import { ApolloConsumer } from "@apollo/client";
import { GET_BUYERS, GET_BUYERS_BY_ID, GET_TEAM } from "../Graphql/Queries/BuyersQuery";
import { CREATE_BUYERS } from "../Graphql/Mutations/BuyersMutation";
import { fetchData, mutateData } from "../Service/graphQlService";
import { CREATE_OR_UPDATE_CONTACTS_BUYERS } from "../Graphql/ContactsMutations/allContactsMutation";
import { GET_BUYER_LIST_QUERY, GET_CONTACT_BUYER_BY_ID, GET_CONTACT_TEAM_BY_ID, GET_CONTACT_TEAM_LIST_QUERY } from "../Graphql/ContactsQueries/contactsQuery";

const limit = 100000;

const priceProps = [
    "price_min",
    "price_max",
];

const dateProps = [
    "last_modified"
];

function parseNumber(data, property) {
    const value = data[property]
    return Number(
      typeof value === "string" ? value.replace(/,/g, "") : value || 0
    );
  }


function convertDataToForm(dbData) {
    const data = { ...dbData };

    priceProps
        .filter((key) => data[key])
        .forEach((key) => {
            const num = Number(data[key]);
            if (num === num) {
                // !isNaN
                data[key] = num.toLocaleString();
            }
        });

    dateProps
        .filter(key => data[key])
        .forEach(key => {
            const str = dateISOtoUS(data[key]);
            if (str !== false)
                data[key] = str;
        });

    return data;
}

function convertFormToData(formData) {
    const data = { ...formData };

    priceProps.forEach((key) => {
        const num = priceToString(data[key]);
        if (num !== false)
            data[key] = num;
    });

    dateProps
        .filter(key => data[key])
        .forEach(key => {
            const str = dateUStoISO(data[key]);
            if (str !== false)
                data[key] = str;
        });

    return data;
}

export default class CRUDBuyer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            original: null,
            isBusy: null,
            isExists: false,
            users: [],
            error: null,
            success: null,
            errorTabs: [],
            currentTab: 0,
            viewMode: this.props.edit || false,
            previousStatus: null,
        };
        this.client = null;

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeInput = this.handleChangeInput.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.params.id !== nextProps.params.id) {
            this.fetch(nextProps.params.id);
        }
    }

    componentDidMount() {
        this.fetch(this.props.params.id);
    }

    fetch(id) {
        if (this.client) {
            this.setState({
                data: null,
                error: null,
                success: null,
            });

            if (id === undefined) {
                this.setState({
                    data: { contact_type: ["Buyer"] },
                    original: {}
                });
                return;
            }
            const token = localStorage.getItem('authToken');
            // this.client
            //     .query({
            //         query: GET_BUYERS_BY_ID,
            //         variables: { arcimedes_row_id: id },
            //         fetchPolicy: "no-cache",
            //         context: {
            //             headers: {
            //                 authorization: `Bearer ${token}`,
            //             },
            //         },
            //     })
            //     .then((res) => {
            //         if (res && res.data && res.data.getBuyer) {
            //             this.setState({
            //                 data: convertDataToForm(res.data.getBuyer),
            //                 original: { ...convertDataToForm(res.data.getBuyer) },
            //                 error: null,
            //             });
            //         } else {
            //             this.setState({
            //                 data: false,
            //                 error: res.errors ? res.errors[0].message : "Unidentified Error",
            //             });
            //         }
            //     })
            //     .catch((error) => {
            //         this.setState({
            //             data: false,
            //             error: error.message || "Unidentified Error",
            //         });
            //     });
            // fetchData(GET_CONTACT_BUYER_BY_ID, { contactid: Number(id) })
            // .then((res) => {
            //     if (res && res.data && res.data.getContactByContactid.contact) {
            //         this.setState({
            //             data: convertDataToForm(res.data.getContactByContactid.contact),
            //             original: { ...convertDataToForm(res.data.getContactByContactid.contact) },
            fetchData(GET_CONTACT_BUYER_BY_ID, { contactid: Number(id) })
            .then((res) => {
                if (res && res.data && res.data.getContactByContactid.contact) {
                    this.setState({
                        data: convertDataToForm(res.data.getContactByContactid.contact),
                        original: { ...convertDataToForm(res.data.getContactByContactid.contact) },
                        error: null,
                    });
                } else {
                    this.setState({
                        data: false,
                        error: res.errors ? res.errors[0].message : "Unidentified Error",
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    data: false,
                    error: error.message || "Unidentified Error",
                });
            });
        }
    }
    async fetchUserData(client) {
        const token = localStorage.getItem('authToken');
        try {
            // const res = await fetchData(GET_BUYERS, {pageOptions: {page: 1, pageSize: limit} })
            const res = await fetchData(GET_BUYER_LIST_QUERY, {type:"Buyer",pageOptions: {page: 1, pageSize: limit} })
            // await client.query({
            //     query: GET_BUYERS,
            //     variables: {pageOptions: {page: 1, pageSize: limit} },fetchPolicy: "no-cache",
            //     context: {
            //         headers: {
            //             authorization: `Bearer ${token}`,
            //         },
            //     },
            // });
            if (res.data && res.data.getContacts.data && res.data.getContacts.data.length) {
                const isExists = res.data.getContacts.data.some((buyer) => {
                        const buyerFirstName = buyer.first_name ? buyer.first_name.toLowerCase() : null;
                        const buyerLastName = buyer.last_name ? buyer.last_name.toLowerCase() : null;
                        const stateFirstName = this.state.data.first_name ? this.state.data.first_name.toLowerCase() : null;
                        const stateLastName = this.state.data.last_name ? this.state.data.last_name.toLowerCase() : null;
                        
                        return (
                            buyerFirstName === stateFirstName &&
                            buyerLastName === stateLastName &&
                          buyer.contact_id !== this.state.data.contact_id
                        );
                }
                );
                this.setState({ isExists });
                return isExists;
            }

            return false;
        } catch (error) {
            console.error("Error fetching users for duplicate validation:", error);
            return false;
        }
    }
    async handleSubmit(client, e) {
        e.preventDefault();

        if (this.state.viewMode) this.setState({ viewMode: false });
        if (!this.state.data.first_name ||
            !this.state.data.last_name) {
            this.setState({ errorTabs: [0], success: null });
            return;
        } else {
            // if (this.state.isBusy || this.state.viewMode === true) return;
            if (this.state.viewMode === true) return;

            this.setState({ errorTabs: [] });

            // this.fetchUserData(0);
            const isDuplicate = await this.fetchUserData(client);
            if (isDuplicate) {
                console.log("Duplicate entry detected.");
                return;
            }
            if (!this.props.params.id) {
                var pageParams = {
                    page: 1,
                    pageSize: 50
                }
                const token = localStorage.getItem('authToken');
                const capRateMax = parseNumber(this.state.data, "cap_rate_max");
                const capRateMin = parseNumber(this.state.data, "cap_rate_min");
                const priceMax = parseNumber(this.state.data, "price_max");
                const priceMin = parseNumber(this.state.data, "price_min");
                // if (client) {
                //     try {
                //         const res = await this.client.mutate({
                //             mutation: CREATE_BUYERS,
                //             variables: {
                //                 cap_rate_max: capRateMax ? capRateMax : null ,
                //                 cap_rate_min: capRateMin ? capRateMin : null,
                //                 category: this.state.data.category,
                //                 cell_phone: this.state.data.cell_phone,
                //                 company_address: this.state.data.company_address,
                //                 company_city: this.state.data.company_city,
                //                 company_name: this.state.data.company_name,
                //                 company_state: this.state.data.company_state,
                //                 company_zip: this.state.data.company_zip,
                //                 deleted: this.state.data.deleted,
                //                 email: this.state.data.email,
                //                 first_name: this.state.data.first_name,
                //                 hsc_follow_up: this.state.data.hsc_follow_up,
                //                 last_modified: this.state.data.last_modified,
                //                 last_name: this.state.data.last_name,
                //                 market: this.state.data.market,
                //                 multi_tenant_subcategory: this.state.data.multi_tenant_subcategory,
                //                 notes: this.state.data.notes,
                //                 phone: this.state.data.phone,
                //                 price_max: priceMax ? priceMax : null,
                //                 price_min: priceMin ? priceMin : null,
                //                 profile: this.state.data.profile,
                //                 single_tenant_subcategory: this.state.data.single_tenant_subcategory,
                //                 status: this.state.data.status,
                //                 strive_agent: this.state.data.strive_agent,
                //                 type: this.state.data.type,
                //                 agent: this.state.data.agent,
                //                 agent_firm: this.state.data.agent_firm,
                //             },
                //             context: {
                //                 headers: {
                //                     authorization: `Bearer ${token}`,
                //                 },
                //             },
                //             // refetchQueries: [{ query: GET_BUYERS, variables: { pageOptions: pageParams } }],
                //         });
                if (client) {
                    const input = {
                        // contact_type:"Buyer",
                        // arcimedes_row_id:"",
                        contact_type: this.state.data.contact_type.length > 1 ?  this.state.data.contact_type.split(",") : ["Buyer"],
                        name: this.state.data.name ? this.state.data.name:'' ,
                        // lenderNotes: this.state.data.lenderNotes ? this.state.data.lenderNotes : "",
                        cap_rate_max: capRateMax ? capRateMax : null ,
                        cap_rate_min: capRateMin ? capRateMin : null,
                        category: this.state.data.category ? this.state.data.category : null,
                        cell_phone: this.state.data.phone ? this.state.data.phone : null,
                        company_address: this.state.data.company_address?  this.state.data.company_address : null,
                        company_city: this.state.data.company_city ? this.state.data.company_city : null,
                        company_name: this.state.data.company_name ? this.state.data.company_name : null,
                        company_state: this.state.data.company_state ? this.state.data.company_state : null,
                        company_zip: this.state.data.company_zip ? this.state.data.company_zip : null,
                        deleted: this.state.data.deleted ? this.state.data.deleted : null,
                        email: this.state.data.email ? this.state.data.email : null,
                        first_name: this.state.data.first_name ? this.state.data.first_name : null,
                        hsc_follow_up: this.state.data.hsc_follow_up ? this.state.data.hsc_follow_up : null,
                        last_modified: this.state.data.last_modified ? this.state.data.last_modified : null,
                        last_name: this.state.data.last_name ? this.state.data.last_name : null,
                        market: this.state.data.market ?  this.state.data.market : null,
                        multi_tenant_subcategory: this.state.data.multi_tenant_subcategory ? this.state.data.multi_tenant_subcategory : null,
                        notes: this.state.data.notes ? sanitizeNotesForInput(this.state.data.notes) : null,
                        phone: this.state.data.phone ? this.state.data.phone : null,
                        price_max: priceMax ? priceMax : null,
                        price_min: priceMin ? priceMin : null,
                        profile: this.state.data.profile ? this.state.data.profile : null,
                        single_tenant_subcategory: this.state.data.single_tenant_subcategory ? this.state.data.single_tenant_subcategory : null,
                        status: this.state.data.status ? this.state.data.status : null,
                        strive_agent: this.state.data.strive_agent ? this.state.data.strive_agent.toString() : null,
                        type: this.state.data.type ? this.state.data.type : null,
                        agent: this.state.data.agent ? this.state.data.agent : null,
                        agent_firm: this.state.data.agent_firm ? this.state.data.agent_firm : null,
                    }
                    
                    try {
                        const res = await mutateData(CREATE_OR_UPDATE_CONTACTS_BUYERS,  {
                            input :input
                         },)
                        // this.client.mutate({
                        //     mutation: CREATE_OR_UPDATE_CONTACTS_BUYERS,
                        //     variables: {
                        //       input:input
                        //     },
                        //     context: {
                        //         headers: {
                        //             authorization: `Bearer ${token}`,
                        //         },
                        //     },
                        //     // refetchQueries: [{ query: GET_BUYERS, variables: { pageOptions: pageParams } }],
                        // });
                        // this.setState({ viewMode: true }, () => this.saveData());
                        // this.setState({ viewMode: true });
                        if (res && res.data) {
                            this.setState({
                                isBusy: false,
                                success: "Saved",
                                viewMode: true
                            }, () => {
                                if (!this.props.edit) {
                                    browserHistory.push({
                                        // pathname: `/buyer/${res.data.createOrUpdateBuyer.buyer.arcimedes_row_id}`,
                                        pathname: `/buyer/${res.data.createOrUpdateContact.contact.contact_id}`,
                                    });
                                }
                            });

                            window.scrollTo(0, 0);
                        }

                    } catch (error) {
                        console.error("Error in handleSubmit:", error);
                    }
                }

            }
            else {
                this.setState({ viewMode: true }, () => this.saveData(client));
            }
        }
    }

    handleChangeInput(key, value) {
        this.setState(prevState => ({
            data: {
                ...prevState.data,
                [key]: value
            }
        }));
    }

    handleChangeDropdown(query, queryType, x, key) {
        const data = { ...this.state.data };
        if (key === 'STATUS') {
            data.last_modified = new Date().toLocaleDateString("en-US");
            if (!query[key]) {
                data.category = null;
                data.type = null;
                data.single_tenant_subcategory = null;
                data.multi_tenant_subcategory = null;
                data.market = null;
                data.price_min = null;
                data.price_max = null;
                data.cap_rate_min = null;
                data.cap_rate_max = null;
                data.strive_agent = null;
            }
        }
        data[key] = query[key];
        this.setState({ data });
    }

    async saveData(client) {
        
        // if (this.state.isBusy) return;

        this.setState({
            isBusy: true,
            error: null,
            success: null,
        });

        Object.keys(this.state.data).forEach((k) => {
            if (!this.state.data[k] || k === "undefined") {
                const newData = { ...this.state.data };
                delete newData[k];
                this.setState({ data: newData });
            }
        });

        var pageParams = {
            page: 1,
            pageSize: 50
        }
        const capRateMax = parseNumber(this.state.data, "cap_rate_max");
        const capRateMin = parseNumber(this.state.data, "cap_rate_min");
        const priceMax = parseNumber(this.state.data, "price_max");
        const priceMin = parseNumber(this.state.data, "price_min");
        const token = localStorage.getItem('authToken');
        // const variables= {
        //     arcimedes_row_id: this.props.params.id,
        //     cap_rate_max: capRateMax ? capRateMax : null ,
        //     cap_rate_min: capRateMin ? capRateMin : null,
        //     category: this.state.data.category,
        //     cell_phone: this.state.data.cell_phone,
        //     company_address: this.state.data.company_address,
        //     company_city: this.state.data.company_city,
        //     company_name: this.state.data.company_name,
        //     company_state: this.state.data.company_state,
        //     company_zip: this.state.data.company_zip,
        //     deleted: this.state.data.deleted,
        //     email: this.state.data.email,
        //     first_name: this.state.data.first_name,
        //     hsc_follow_up: this.state.data.hsc_follow_up,
        //     last_modified: this.state.data.last_modified,
        //     last_name: this.state.data.last_name,
        //     market: this.state.data.market,
        //     multi_tenant_subcategory: this.state.data.multi_tenant_subcategory,
        //     notes: this.state.data.notes,
        //     phone: this.state.data.phone,
        //     price_max: priceMax ? priceMax : null,
        //     price_min: priceMin ? priceMin : null,
        //     profile: this.state.data.profile,
        //     single_tenant_subcategory: this.state.data.single_tenant_subcategory,
        //     status: this.state.data.status,
        //     strive_agent: this.state.data.strive_agent,
        //     type: this.state.data.type,
        //     agent: this.state.data.agent,
        //     agent_firm: this.state.data.agent_firm,
        // };
const input = {
    // contact_type:"Buyer",
    contact_type: this.state.data.contact_type.length > 1 ?  this.state.data.contact_type.split(",") : ["Buyer"],
    name:this.state.data.contact_type.includes("Lender") ? this.state.data.name : "",
    // lenderNotes: this.state.data.contact_type.includes("Lender") ? this.state.data.lenderNotes : "",
    contact_id: this.props.params.id ? Number(this.props.params.id) : null,
    cap_rate_max: capRateMax ? capRateMax : null ,
    cap_rate_min: capRateMin ? capRateMin : null,
    category: this.state.data.category ? this.state.data.category : null,
    cell_phone: this.state.data.phone ? this.state.data.phone : null,
    company_address: this.state.data.company_address ? this.state.data.company_address : null,
    company_city: this.state.data.company_city ? this.state.data.company_city : null,
    company_name: this.state.data.company_name ? this.state.data.company_name : null,
    company_state: this.state.data.company_state ? this.state.data.company_state : null, 
    company_zip: this.state.data.company_zip ? this.state.data.company_zip : null,
    deleted: this.state.data.deleted ? this.state.data.deleted : null,
    email: this.state.data.email ? this.state.data.email : null,
    first_name: this.state.data.first_name ? this.state.data.first_name : null,
    hsc_follow_up: this.state.data.hsc_follow_up ?  this.state.data.hsc_follow_up : null,
    last_modified: this.state.data.last_modified ? this.state.data.last_modified : null,
    last_name: this.state.data.last_name ? this.state.data.last_name : null,
    market: this.state.data.market ? this.state.data.market : null,
    multi_tenant_subcategory: this.state.data.multi_tenant_subcategory ? this.state.data.multi_tenant_subcategory : null,
    notes: this.state.data.notes ? sanitizeNotesForInput(this.state.data.notes) : null,
    phone: this.state.data.phone ? this.state.data.phone : null,
    price_max: priceMax ? priceMax : null,
    price_min: priceMin ? priceMin : null,
    profile: this.state.data.profile ? this.state.data.profile : null,
    single_tenant_subcategory: this.state.data.single_tenant_subcategory ? this.state.data.single_tenant_subcategory : null,
    status: this.state.data.status ? this.state.data.status : null,
    strive_agent: this.state.data.strive_agent ? this.state.data.strive_agent.toString() : null,
    type: this.state.data.type ? this.state.data.type : null,
    agent: this.state.data.agent ?  this.state.data.agent : null,
    agent_firm: this.state.data.agent_firm ? this.state.data.agent_firm : null,
}
        try {
            Promise.all([
                // client.mutate({
                //     mutation: CREATE_BUYERS,
                //     variables: {
                //         arcimedes_row_id: this.props.params.id,
                //         cap_rate_max: capRateMax ? capRateMax : null ,
                //         cap_rate_min: capRateMin ? capRateMin : null,
                //         category: this.state.data.category,
                //         cell_phone: this.state.data.cell_phone,
                //         company_address: this.state.data.company_address,
                //         company_city: this.state.data.company_city,
                //         company_name: this.state.data.company_name,
                //         company_state: this.state.data.company_state,
                //         company_zip: this.state.data.company_zip,
                //         deleted: this.state.data.deleted,
                //         email: this.state.data.email,
                //         first_name: this.state.data.first_name,
                //         hsc_follow_up: this.state.data.hsc_follow_up,
                //         last_modified: this.state.data.last_modified,
                //         last_name: this.state.data.last_name,
                //         market: this.state.data.market,
                //         multi_tenant_subcategory: this.state.data.multi_tenant_subcategory,
                //         notes: this.state.data.notes,
                //         phone: this.state.data.phone,
                //         price_max: priceMax ? priceMax : null,
                //         price_min: priceMin ? priceMin : null,
                //         profile: this.state.data.profile,
                //         single_tenant_subcategory: this.state.data.single_tenant_subcategory,
                //         status: this.state.data.status,
                //         strive_agent: this.state.data.strive_agent,
                //         type: this.state.data.type,
                //         agent: this.state.data.agent,
                //         agent_firm: this.state.data.agent_firm,
                //     },
                //     context: {
                //         headers: {
                //             authorization: `Bearer ${token}`,
                //         },
                //     },
                //     // refetchQueries: [{ query: GET_BUYERS, variables: { pageOptions: pageParams } }],
                // }),
                mutateData(CREATE_OR_UPDATE_CONTACTS_BUYERS,  {
                    input :input
                 },),
                // client.query({
                //     query: GET_TEAM, variables: { arcimedes_row_id: this.state.data.strive_agent ? this.state.data.strive_agent : '' },
                //     fetchPolicy: "no-cache",
                //     context: {
                //         headers: {
                //             authorization: `Bearer ${token}`,
                //         },
                //     },
                // })
                // mutateData(CREATE_BUYERS, variables),
                // client.query({
                //     query: GET_TEAM, variables: { arcimedes_row_id: this.state.data.strive_agent ? this.state.data.strive_agent : '' },
                //     fetchPolicy: "no-cache",
                //     context: {
                //         headers: {
                //             authorization: `Bearer ${token}`,
                //         },
                //     },
                // })
            //     fetchData(GET_TEAM, { arcimedes_row_id: this.state.data.strive_agent ? this.state.data.strive_agent : '' })
            // ])
            // .then((res) => {
                
            //     let previousStatus;
            //     if (res && res[0].data && res[0].data.createOrUpdateBuyer && res[1].data && res[1].data.getBuyerTeamMembers) {
            //         const buyerData = res[0].data.createOrUpdateBuyer.buyer;
                fetchData(GET_CONTACT_TEAM_BY_ID, { contactid : this.state.data.strive_agent ? Number(this.state.data.strive_agent) : '' })
            ])
            .then((res) => {
                
                let previousStatus;
                // if (res && res[0].data && res[0].data.createOrUpdateBuyer && res[1].data && res[1].data.getBuyerTeamMembers) {
                //     const buyerData = res[0].data.createOrUpdateBuyer.buyer;
                if (res && res[0].data && res[0].data.createOrUpdateContact && res[1].data && res[1].data.getContactByContactid.contact) {
                    const buyerData = res[0].data.createOrUpdateContact.contact;
                    //previousStatus = this.state.original.status; //it should be there but i removed to get saved on UI screen when we edit and save
                    this.setState({
                        isBusy: false,
                        success: "Saved",
                        original: res.data,
                    }, () => {
                        if (!this.props.edit) {
                            browserHistory.push({
                                // pathname: `/buyer/${res.data.createOrUpdateBuyer.buyer.arcimedes_row_id}`,
                                pathname: `/buyer/${res.data.createOrUpdateContact.contact.contact_id}`,
                            });
                        }
                    });

                    window.scrollTo(0, 0);
                    const responseDetails = {
                        success: true,
                        previousStatus,
                        status: buyerData.status,
                        category: capitalizeAll(buyerData.category),
                        type: formatType(buyerData.type),
                        market: capitalizeAll(buyerData.market),
                        tenant_subcategory: buyerData.type === "MT" ? addSpaceAfterComma(buyerData.multi_tenant_subcategory) : buyerData.type === "STNL" ? addSpaceAfterComma(buyerData.single_tenant_subcategory) : null,
                        price_min: buyerData.price_min,
                        price_max: buyerData.price_max,
                        cap_rate_min: buyerData.cap_rate_min,
                        cap_rate_max: buyerData.cap_rate_max,
                        notes: buyerData.notes,
                        strive_agent: res[1].data.getTeam && res[1].data.getTeam.length ? formatName(res[1].data.getTeam) : null,
                        LINK: `${url}buyers?FIRST_NAME=${buyerData.first_name}&LAST_NAME=${buyerData.last_name}`
                    };

                    if (responseDetails.success && responseDetails.status === '1031-Buyer') {
                        sendEmailNotification({ data: responseDetails, type: 'buyer-status-email' })
                    }
                    if (responseDetails.success && !responseDetails.previousStatus && responseDetails.status === 'Active') {
                        sendEmailNotification({ data: responseDetails, type: 'buyer-status-email' })
                    }

                } else {
                    this.setState({
                        isBusy: null,
                        data: null,
                        original: null,
                        error: res && res.errors && res.errors[0] ? res.errors[0].message : "Unspecified error",
                    });
                }
            })
        } catch (error) {
            console.error("Error in saveData:", error);
            this.setState({
                isBusy: false,
                data: null,
                error: error.message || "Unspecified error",
                original: null
            });
        }
    }


    render() {
        const data = this.state.data;
        const { edit, isSuper } = this.props;

        return (
            <ApolloConsumer>
                {client => {
                    if (!this.client) this.client = client;
                    return (
                        <CRUD
                            tabsData={[
                                {
                                    name: "Buyer",
                                    renderedComponent: (
                                        <BuyerInfo
                                            isExists={this.state.isExists}
                                            data={data}
                                            handleChangeInput={this.handleChangeInput}
                                            handleChangeDropdown={this.handleChangeDropdown}
                                            viewMode={this.state.viewMode}
                                            deleted={data && data.deleted === "1"}
                                            handleParentDropdownChange={this.handleChangeDropdown}
                                        />
                                    ),
                                },
                                {
                                    name: "Buyer Company",
                                    renderedComponent: (
                                        <BuyerCompanyInfo
                                            data={data}
                                            handleChangeInput={this.handleChangeInput}
                                            handleChangeDropdown={this.handleChangeDropdown}
                                            viewMode={this.state.viewMode}
                                            deleted={data && data.deleted === "1"}
                                        />
                                    ),
                                },
                            ]}
                            backLink={`${arc.path.base}buyers`}
                            edit={edit}
                            state={this.state}
                            setState={this.setState.bind(this)}
                            handleSubmit={this.handleSubmit.bind(this, client)}
                            saveData={() => this.saveData(client)}
                            type="buyer"
                            backName="BUYERS"
                            title={data && `${data.first_name} ${data.last_name}`}
                            isSuper={isSuper}
                        />
                    )
                }}
            </ApolloConsumer>

        );
    }
}

